// extracted by mini-css-extract-plugin
export default {"ExpandablePanel":"ExpandablePanel__ExpandablePanel___PBw_t","title":"ExpandablePanel__title___MYlM9","content":"ExpandablePanel__content___c4Fxo"};